"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentFactory = exports.addWrappers = exports.addComponents = void 0;

var _react = _interopRequireDefault(require("react"));

var _wrappers = require("./wrappers");

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ComponentLibrary = {};

var WrapperLibrary = _objectSpread({}, _wrappers.Wrappers);

var addComponents = function addComponents(comps) {
  ComponentLibrary = _objectSpread(_objectSpread({}, ComponentLibrary), comps);
};

exports.addComponents = addComponents;

var addWrappers = function addWrappers(wraps) {
  WrapperLibrary = _objectSpread(_objectSpread({}, WrapperLibrary), wraps);
};

exports.addWrappers = addWrappers;

var getKey = function getKey(config, i) {
  return (0, _lodash["default"])(config, "key", "key-".concat(i.join("-")));
};

var getBasicJSX = function getBasicJSX(config) {
  return function (_ref) {
    var children = _ref.children,
        props = _objectWithoutProperties(_ref, ["children"]);

    return /*#__PURE__*/_react["default"].createElement(config.type, props, children);
  };
};

var getComponent = function getComponent(config) {
  return typeof config === "function" ? config : typeof config === "string" ? function () {
    return config;
  } : typeof config.type === "function" ? config.type : (0, _lodash["default"])(ComponentLibrary, config.type, getBasicJSX(config));
};

var applyWrappers = function applyWrappers(Component, config) {
  return (0, _lodash["default"])(config, "wrappers", []).reduce(function (a, c) {
    if (typeof c === "string") {
      return (0, _lodash["default"])(WrapperLibrary, c, function (d) {
        return d;
      })(a);
    } else if (typeof c === "function") {
      return c(a);
    } else if (_typeof(c) === "object") {
      var type = c.type,
          options = c.options;
      return (0, _lodash["default"])(WrapperLibrary, type, function (d) {
        return d;
      })(a, options);
    }

    return a;
  }, Component);
};

var processConfig = function processConfig(config) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0];
  var outerConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var Component = getComponent(config);

  if (_typeof(Component) === "object") {
    return processConfig(Component, i, config);
  }

  Component = applyWrappers(applyWrappers(Component, outerConfig), config);
  var children = [].concat(_toConsumableArray((0, _lodash["default"])(outerConfig, "children", [])), _toConsumableArray((0, _lodash["default"])(config, "children", []))); // const processConfig = (config, i = [0]) => {
  //   const Component = applyWrappers(getComponent(config), config),
  //     children = get(config, "children", []);
  // console.log("CHILDEN:", children)
  // console.log("CONFIG PROPS:", config.props)

  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    key: getKey(config, i)
  }, (0, _lodash["default"])(outerConfig, "props", {}), (0, _lodash["default"])(config, "props", {})), children.map(function (child, ii) {
    return processConfig(child, [].concat(_toConsumableArray(i), [ii]));
  })); // return React.createElement(Component,
  //   { ...config.props, key: getKey(config, i) },
  //   children.map((child, i) => processConfig(child, i))
  // );
};

var ComponentFactory = function ComponentFactory(_ref2) {
  var config = _ref2.config;
  return processConfig(config);
};

exports.ComponentFactory = ComponentFactory;